import type { usePager } from "./usePager";

interface PagerControlsProps {
  pager: ReturnType<typeof usePager<unknown>>;
  noun: string;
  step: number;
}

export function PagerControls({ pager, noun, step }: PagerControlsProps) {
  if (!pager.hasMore && !pager.canCollapse) return null;
  return (
    <div className="pager">
      <span>{pager.shown} of {pager.total} {noun}</span>
      <span className="pager-actions">
        {pager.hasMore ? <button className="chip" type="button" onClick={pager.showMore}>Show {Math.min(step, pager.total - pager.shown)} more</button> : null}
        {pager.hasMore && pager.total - pager.shown > step ? <button className="chip" type="button" onClick={pager.showAll}>Show all</button> : null}
        {pager.canCollapse ? <button className="chip" type="button" onClick={pager.collapse}>Collapse</button> : null}
      </span>
    </div>
  );
}
